// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"SummaryTable_tableWrapper__3A--Q","table":"SummaryTable_table__2MD2J","tCell":"SummaryTable_tCell__2RfXs"};